import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import NorthAmericaConsulting from './components/NorthAmericaConsulting';
import DatabricksConsulting from './components/DatabricksConsulting';
import PowerPlatform from './components/PowerPlatform';
import AIConsulting from './components/AIConsulting';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <Services />
        <NorthAmericaConsulting />
        <DatabricksConsulting />
        <PowerPlatform />
        <AIConsulting />
        <WhyChooseUs />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
